<template>
  <span class="tr-text">
    <span :style="{ 'font-size': calculateFont(size) + 'px' }" v-katex="text" v-if="type"></span>
    <span v-html="text" v-else></span>
  </span>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'tr-text',
  props: {
    text: {
      type: String,
      default: '',
    },
    type: {
      type: Boolean,
      default: false,
    },
    size: {
      type: null,
      default: function () {
        return {};
      },
    },
  },
  methods: {
    calculateFont(font) {
      let newFont = (100 * font) / 121;
      return newFont;
    },
  },
};
</script>
